module.exports = __webpack_public_path__ + "img/icon_mid_en.78c521ca.png";